/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {eventObserver} from "../modules/eventObserver";
import {mediaQuery} from "../modules/common";

gsap.registerPlugin(CustomEase, ScrollTrigger);
CustomEase.create("slide", ".32, .95, .6, 1");

/* =============================================================
 * function
 * ========================================================== */

export default function exe(data) {
  const namespace = data.current.namespace; // barbajsからdataを取得

  // 遷移元ページが存在しない場合（TOPページにランディングした場合）のみ実行
  if (namespace === '' || namespace === 'home') {
    const header = document.querySelector('.header');
    gsap.set(header, { opacity: 0 }); // 初期化
  }

  openingAnim(namespace);
  menuSwitcher();
}


function openingAnim(namespace) {
  // TOPページのみ最優先で実行
  // 他ページからの遷移では実行しないため、barbaJSを回避
  const opening = document.querySelector('#opening');
  const kv = document.querySelector('#kv');

  if (namespace === '' || namespace === 'home') {
    // 遷移元ページが存在しない場合（TOPページにランディングした場合）のみ実行
    kv.style.display = 'none';  // デフォルトのKVセクションは非表示

    if (opening != null) {

      const header = document.querySelector('.header');
      const imgMask = opening.querySelector('.opening_figure');
      const img = imgMask.querySelector('.opening_figure_img');
      let tl;

      header.classList.add('negative');

      if (mediaQuery(window.innerWidth) !== 'sp') {

        const v = {
          img: {
            marginRight: {},
          },
          imgMask: {
            width: {},
            height: {},
            marginTop: {},
            marginRight: {},
            borderRadius: {},
          },
        };

        const calc = () => {
          if (window.innerWidth > 1280) {
            // デバイスサイズ1281px以上時（px管理）
            v.img.marginRight.start = -1030;
            v.img.marginRight.end = -1330;

            v.imgMask.width.start = 830;
            v.imgMask.height.start = 1276;
            v.imgMask.marginTop.start = -638;
            v.imgMask.marginRight.start = -880;
            v.imgMask.borderRadius.start = "415px";

            v.imgMask.width.end = 2400;
            v.imgMask.height.end = 1768;
            v.imgMask.marginTop.end = -884;
            v.imgMask.marginRight.end = -1200;
            v.imgMask.borderRadius.end = "2400px 1240px";
          } else {
            // デバイスサイズ1280px未満時（vw管理）
            v.img.marginRight.start = "-80.46875vw";
            v.img.marginRight.end = "-103.90625vw";

            v.imgMask.width.start = "64.84375vw";
            v.imgMask.height.start = "99.6875vw";
            v.imgMask.marginTop.start = "-49.84375vw";
            v.imgMask.marginRight.start = "-68.75vw";
            v.imgMask.borderRadius.start = "35.15625vw";

            v.imgMask.width.end = "187.5vw";
            v.imgMask.height.end = "138.125vw";
            v.imgMask.marginTop.end = "-69.0625vw";
            v.imgMask.marginRight.end = "-93.75vw";
            v.imgMask.borderRadius.end = "187.5vw 96.875vw";
          }
        };
        calc(); // 読み込み時の初回計算

        gsap.fromTo(imgMask, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 1.2,
          ease: "slide",
        });

        tl = gsap.timeline({
          scrollTrigger: {
            trigger: opening,
            scrub: 3,
            pin: true,
            anticipatePin: 1,
            start: "top top",
            end: "+=100%",
            invalidateOnRefresh: true, // update on resize
            onRefresh: calc, // resize時に再計算
          },
        });

        tl
          .to(img, {
            marginRight: () => v.img.marginRight.start,
            duration: 4,
          }, ">")

          .to(imgMask, {
            width: () => v.imgMask.width.start,
            height: () => v.imgMask.height.start,
            marginTop: () => v.imgMask.marginTop.start,
            marginRight: () => v.imgMask.marginRight.start,
            borderTopLeftRadius: () => v.imgMask.borderRadius.start,
            borderTopRightRadius: () => v.imgMask.borderRadius.start,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            duration: 4,
          }, "-=.8")

          .to(img, {
            scale: 0.8,
            duration: 4,
          }, "<")

          .to(imgMask, {
            width: () => v.imgMask.width.end,
            height: () => v.imgMask.height.end,
            marginTop: () => v.imgMask.marginTop.end,
            marginRight: () => v.imgMask.marginRight.end,
            borderTopLeftRadius: () => v.imgMask.borderRadius.start,
            borderTopRightRadius: () => v.imgMask.borderRadius.start,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            duration: 5,
          }, ">")

          .to(img, {
            marginRight: () => v.img.marginRight.end,
            duration: 5.5,
            scale: 1,
          }, "<.5")

          .to(imgMask, {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomLeftRadius: () => v.imgMask.borderRadius.end,
            borderBottomRightRadius: () => v.imgMask.borderRadius.end,
            duration: 4,
          }, ">")
          .call(() => {
            // タイムラインに挿入するとページ遷移に伴ったスクロール判定でヘッダーが消えるためコールバック関数にて対応
            gsap.to(header, {
              opacity: 1,
              duration: 4,
            });
          }, null, "<")
        ;

      } else {
        tl = gsap.timeline({
          repeat: 0,
          ease: "slide",
          invalidateOnRefresh: true, // update on resize
        });

        tl
          .fromTo(imgMask, {
            opacity: 0,
          }, {
            opacity: 1,
            duration: .8,
          })

          .to(img, {
            scale: 0.8,
            marginRight: "-196.9230769231vw", // -768
            duration: 2.4,
          }, "+=.8")

          .to(imgMask, {
            width: "123.0769230769vw", // 480,
            height: "262.5641025641vw", // 1024,
            marginTop: "-131.2820512821vw", // -512,
            marginRight: "-61.5384615385vw", // -240,
            borderTopLeftRadius: "61.5384615385vw", // 240
            borderTopRightRadius: "61.5384615385vw", // 240
            borderBottomLeftRadius: "0",
            borderBottomRightRadius: "0",
            duration: 1,
          }, "-=.8")

          .to(img, {
            scale: 1,
            duration: 0.7,
          }, "<.3")

          .to(header, {
            opacity: 1,
            duration: 0.7,
          }, "<")
          // .call(() => { header.classList.add('negative'); }, null, "<")

          .to(imgMask, {
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0",
            borderBottomLeftRadius: "266.6666666667vw 205.1282051282vw", // "1040px 800px"
            borderBottomRightRadius: "266.6666666667vw 205.1282051282vw", // "1040px 800px"
            duration: 0.7,
          }, ">")
        ;

      }


      const nextSection = document.querySelector('#concept');
      const enterEffect = () => {
        header.classList.remove('negative');
      };

      const leaveEffect = () => {
        header.classList.add('negative');
      };

      ScrollTrigger.create({
        trigger: nextSection,
        start: 'top center', // top-=100 bottom
        end: 'bottom center',
        invalidateOnRefresh: true, // update on resize
        onEnter: enterEffect,
        onEnterBack: leaveEffect,
        // onLeave: leaveEffect,
        onLeaveBack: leaveEffect,
      });

    }

  } else {
    // 遷移元ページが存在する場合
    opening.style.display = 'none';
  }
}


function menuSwitcher() {
  const listeners = [];
  let onObj;
  let offObj;
  const btn = document.querySelectorAll(".js-switcherBtn");
  const onSwitcher = (e) => {
    const target = document.querySelector('[data-modal-area="' + e.currentTarget.dataset.modalBtn + '"]');
    target.classList.add('active');
  };
  const offSwitcher = (e) => {
    const target = document.querySelector('[data-modal-area="' + e.currentTarget.dataset.modalBtn + '"]');
    target.classList.remove('active');
  };

  const init = () => {
    if (mediaQuery() !== 'sp') {
      if (btn.length > 0) {
        btn.forEach(elem => {
          onObj = {
            btn: elem,
            handleEvent: onSwitcher,
          };
          offObj = {
            btn: elem,
            handleEvent: offSwitcher,
          };
          elem.addEventListener('mouseenter', onObj, false);
          elem.addEventListener('mouseleave', offObj, false);
          listeners.push([elem, 'mouseenter', onObj, false]);
          listeners.push([elem, 'mouseleave', offObj, false]);
        });
      }
    }
  };

  init();
  window.addEventListener("resize", init);
  eventObserver.observeEvents(listeners);
}


